import React from 'react';

export default function Footer() {
  return (
    <footer className="k-footer">
      <strong>Questions?</strong> Call Katapult at
      <a href="tel:833-KATAPULT (833-528-2785)">833-KATAPULT (833-528-2785)</a>
    </footer>
  );
}
